// extracted by mini-css-extract-plugin
export default {"page":"Page_Teacher_evalucacion_page__CZcc1","loading":"Page_Teacher_evalucacion_loading__1NjVg"};